export default {
  namespaced: true,

  state: {
    brokersList: [],
    brokersData: {},
    editItem: null,
    isLoading: false,
    error: null
  },
  getters: {
    brokersList(state) {
      return state.brokersList
    },
    brokersData(state) {
      return state.brokersData
    },
    editItem(state) {
      // console.log(state.editItem)
      return state.editItem
    },
    isLoading(state) {
      return state.isLoading
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_BROKERS(state, brokersList) {
      console.log(brokersList)
      state.brokersList = brokersList 
    },
    SET_BROKER_DATA(state, brokersData) {
      state.brokersData = brokersData
    },
    GET_BROKER(state, index) {
      let editItemIndex = state.brokersList.map(function(item) { return item.id; }).indexOf(parseInt(index));
      state.editItem = state.brokersList[editItemIndex]
    },
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    REMOVE_ROW(state, index) {
      let removeIndex = state.brokersList.map(function(item) { return item.id; }).indexOf(index);
      state.brokersList.splice(removeIndex, 1);
    },
  },
  actions: {
    deleteRow({commit}, dispatch_data) {
      commit('REMOVE_ROW', dispatch_data.id)
    },
  }
}
